import type { BackendRouteDefinition } from '../types';

interface SendGoogleEmailRequestData {
  subject: string;
  body: string;
  recipients: string[];
  fromEmailAddress?: string;
}

// Flipped from `transport: 'callable'` to `transport: 'api'` by S2-WB2
// (PRA-788). Now served by `api-core-node` at
// `POST /api/firms/google-workspace/emails`. See `generateGoogleAuthUrl.ts`
// for the retirement-deferred callable note.

export const sendGoogleEmailRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/google-workspace/emails',
  // Keep the request body unchanged so the existing firms wrapper passes
  // through `SendGoogleEmail.RequestData` without remapping the legacy
  // callable payload shape.
  body: (requestData: SendGoogleEmailRequestData) => requestData,
} as const satisfies BackendRouteDefinition;
